function packageFunc (param:string) {
    console.log(param)
}
export default {
    install: function (Vue:any) {
        Vue.prototype.globalCallback = (param:string) => packageFunc(param)
    }
}
